export default {
    title: 'Facturi',
    table: {
        id_mb: 'ID MB',
        id_bou: 'ID BOU',
        client_id: 'ID client',
        client_name: 'Nume client',
        period: 'Perioada facturata',
        created_at: 'Data creeare factura',
        invoice_date: 'Data facturare',
        status: 'Status',
        total: 'Valoare totala',
        payment_due: 'Scadenta/Incasari',
        payment_status: {
            0: 'N/A',
            1: 'Scadenta in termen',
            2: 'Scadenta depasita',
            3: 'Incasat',
        },
        crm_status : "Status CRM / SPV",
        crm_status_list: {
            0: 'Neincarcat',
            '' : 'Neincarcat',
            'E': 'Eroare',
            'U': 'Incarcat',
            'EI': 'Eroare finalizare',
        },
        type: 'Tip factura',
        types: {
            1: 'Factura standard',
            2: 'Factura storno'
        },
        source: 'Sursa',
        sources: {
            1: 'Sistem',
            2: 'Manual'
        },
        status_list: {
            1: 'In asteptare',
            2: 'Eroare',
            10: 'Facturat',
            11: 'Anulat',
            12: 'Stornat'
        },
        filters: {
            invoice_name: 'Numar factura',
            client: 'Client',
            invoice_status: 'Status factura'
        }

    },
    invoice_details: {
        title: 'Detalii',
        details: 'Detalii factura',
        requests: 'Solicitari incluse in factura',

        subscription: {
            type: 'Tip subscriptie',
            users: 'Nr utilizatori'
        },
        details_data: {
            invoice_id: 'Numar factura',
            client_id: 'Cod client',
            client_name: 'Nume client',
            start_date: 'Data emitere',
            status: 'Status',
            details: 'Descriere',
            details_invoice: 'Descriere factura storno',
            filters: {
                title: 'Filtre',
                benefit: 'Tip beneficiu',
                partner: 'Partener',
                company: 'Companie'
            },
            buttons: {
                select: 'Selectare',
                save: 'Salveaza tva',
                create: 'Trimite factura',
                credit: 'Storneaza selectia',
                credit_all: 'Storneaza total',
                download_invoice: 'Descarca factura',
                apply_filters: 'Aplica filtrele',
                add_subscription: 'Adauga subscriptie',
                add_payment: 'Adauga incasare',
                save_payments: 'Salveaza incasari'
            }
        },
        table: {
            order_request_id: 'Nr. Solicitare',
            placed_at: 'Plasat la data',
            company_employee: 'Beneficiar',
            client: 'Client',
            benefit_name: 'Nume beneficiu',
            status: 'Status',
            status_invoice: 'Status facturare',
            partner: 'Partener',
            quantity: 'Cantitate',
            value: 'Valoare',
            vat: 'TVA',
            vat_value: 'Valoare TVA',
            benefit_sub_type: 'Tip'
        },
        payment_table: {
            amount: 'Suma',
            date: 'Data',
            due_date: 'Data scadenta',
            total_amount: 'Valoarea totala',
            partial_amount: 'Incasat partial',
            to_pay: 'De incasat'
        }
    },
    invoice_create: {
        total: 'Suma totala:',
        total_vat: 'Total tva:',
        buttons: {
            create: 'Adauga factura manuala'
        },
        subscription: {
            title: 'Subscriptie',
            invoice_settings: 'Setari pentru facturi',
            users: 'Nr. utilizatori',
            company: 'Subscriptie tip companie'
        },
        error_messages: {
            date_period: 'Perioada de facturare este obligatorie daca in factura este inclusa doar subscriptia',
            invoice_date: 'Data de facturare nu poate fi mai veche de 3 zile si nici mai mica decat data de sfarsit a perioadei de facturare'
        }
    },
    alert_messages: {
        credit: {
            success: 'Stornare efectuata cu success'
        },
        invoice_create: {}
    }
}
